export const PROMPTS_ADD_COMPONENT = 'PROMPTS_ADD_COMPONENT';
export const PROMPTS_CLEAR = 'PROMPTS_CLEAR';
export const PROMPTS_CLEAR_SPECIFIC = 'PROMPTS_CLEAR_SPECIFIC';
